exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p[data-v-7744ffef] {\n  margin: 0;\n  padding: 0;\n  font-size: 14px;\n}\n", ""]);

// exports
